Ember.Application.initializer
  name: 'pageRouteAsBodyClass'

  initialize: (container, application) ->
    session = container.lookup('service:session')
    Ember.Route.reopen
      setBodyClasses: (->
        cssClass = @toCssClass();

        if (cssClass != 'application')
          Ember.$('body').addClass(cssClass);

        role = session.get('currentUser.account.role')
        Ember.$('body').addClass("current-user-role-#{role}");
        Ember.$('body').addClass('ios-device') if /iPad|iPhone|iPod/.test(navigator.userAgent)
      ).on('activate'),

      removeBodyClasses: (->
        Ember.$('body').removeClass(@toCssClass());
      ).on('deactivate'),

      toCssClass: (->
        return @routeName.replace(/\./g, '-').dasherize() + '-page';
      )
